<template>
    <div class="prebillContainer">
        <el-divider></el-divider>
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-info">
                        <div class="box-header with-border">
                            <h3 class="box-title">
                                Cargar Documento
                            </h3>
                        </div>
                        <div class="box-body box-body-prebill">
                            <el-form :model="document" ref="formRef" :rules="formRules" label-width="auto" class="form-container">
                                <el-divider> Datos del Documento </el-divider>
                                <el-form-item size="small" label="Tipo de operación" class="form-select" prop="documenttype">
                                    <el-select v-model="document.documenttype" placeholder="Tipo de operación">
                                        <el-option
                                            v-for="item in documentType"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item  label="Código de AFIP" class="form-input" size="small" prop="codigoAFIP">
                                    <el-input  v-model="document.codigoAFIP"></el-input>
                                </el-form-item>
                                <el-form-item label="Letra" class="form-input" size="small" prop="letra">
                                    <el-input v-model="document.letra"></el-input>
                                </el-form-item>
                                <el-form-item label="Número" class="form-input" size="small" prop="numero">
                                    <el-input v-model="document.numero"></el-input>
                                </el-form-item>
                                <el-form-item label="Proveedor" class="form-input" size="small" prop="proveedor" >
                                    <el-select filterable v-model="document.proveedor" class="proveedorList" :disabled="this.$store.state.user.isProvider">
                                        <el-option
                                            v-for="item in providers"
                                            :key="item.idCompany"
                                            :label="item.company"
                                            :value="item.idCompany"
                                            class="proveedorList"
                                            >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-divider>Datos CAE</el-divider>
                                <el-form-item label="Fecha de Vencimiento" class="form-input" size="small" prop="fechaVencimiento">
                                    <el-date-picker
                                        class="form-date"
                                        v-model="document.fechaVencimiento"
                                        type="date"
                                        placeholder="Selecciona fecha de vencimiento"
                                        :default-value="new Date()"
                                    />
                                </el-form-item>
                                <el-form-item label="Nº" class="form-input" size="small" prop="NroCAE">
                                    <el-input v-model="document.NroCAE"></el-input>
                                </el-form-item>
                                <el-form-item style="margin-left: 0;" size="small" label="PDF" class="form-upload" prop="pdfDoc">
                                    <pdf-file
                                    v-bind:pdfFilePath.sync="document.pdfDoc"
                                    :habModificaPdf="habModificaPdf"
                                    id="documento"
                                    prop="pdfDoc"
                                    class="form-pdf"
                                />
                                </el-form-item>
                                <el-divider v-if="loadOperationType === true" content-position="left">Datos de Referencia</el-divider>
                                <el-form-item v-if="loadOperationType === true" size="small" label="Tipo de transacción" class="form-select">
                                    <el-select v-model="document.ocType" placeholder="Tipo de transacción">
                                    <el-option
                                        v-for="item in acceptanceType"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                </el-form-item>
                                <el-form-item size="small" class="form-input" v-if="document.ocType === '1'" :key="index">
                                    <el-row>
                                        <el-col :span="24">
                                            <p class="input-text">Número de operación</p>
                                        </el-col>
                                        <el-col :span="12" class="input-view1">
                                            <el-input v-model="document.ocNumber" placeholder="Numero de HES"></el-input>
                                        </el-col>
                                        <el-col :span="12" class="input-view2">
                                            <el-button style="margin-left: 35px;" type="warning" @click="addOcNumber">+</el-button>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <el-form-item size="small" class="form-input" v-if="document.ocType === '1'" v-for="(ocNumber, index) in document.ocNumbers" :key="index">
                                    <el-row>
                                        <el-col :span="12" class="input-view1">
                                            <el-input v-model="ocNumber.value" placeholder="Numero de HES"></el-input>
                                        </el-col>
                                        <el-col :span="12" class="input-view2">
                                            <el-button style="margin-left: 35px;" type="warning" @click="deleteOcNumber(index)">-</el-button>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <el-form-item size="small" class="form-input" v-if="document.ocType === '2'">
                                    <el-row>
                                        <el-col :span="24">
                                            <p class="input-text">Número de operación</p>
                                        </el-col>
                                        <el-col :span="12" class="input-view1">
                                            <el-input placeholder="Numero de MIGO" v-model="document.migoNumber"></el-input>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <el-divider>Importes</el-divider>
                                <el-form-item label="Importe Total" class="form-input" size="small" prop="importeTotal">
                                    <el-input v-model="document.importeTotal"></el-input>
                                </el-form-item>
                                <el-form-item label="Importe Impuesto" class="form-input" size="small" prop="importeImpuesto">
                                    <el-input v-model="document.importeImpuesto"></el-input>
                                </el-form-item>
                                <el-form-item label="Porcentaje Impuesto" class="form-input" size="small" prop="porcentajeImpuesto">
                                    <el-input v-model="document.porcentajeImpuesto"></el-input>
                                </el-form-item>
                                <el-form-item label="Moneda" class="form-input" size="small" prop="moneda">
                                    <el-input v-model="document.moneda"></el-input>
                                </el-form-item>
                                <el-form-item label="Tipo de Cambio" class="form-input" size="small" prop="tipoDeCambio">
                                    <el-input v-model="document.tipoDeCambio"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-divider></el-divider>
                            <el-dialog :visible.sync="showModal" title="Confirmar acción" center>
                                <div style="display:flex; flex-direction: column; justify-content: center; align-items: center;">
                                    <div>
                                        <p style="font-size: 16px;"> ¿Está seguro que desea envíar el documento? </p>
                                        <div style="margin-top:2rem; display:flex; justify-content: center;">
                                            <el-button class="btn" type="success" v-on:click="createDocument">
                                                Confirmar
                                            </el-button>
                                            <el-button class="btn" type="danger" v-on:click="() => showModal = false">
                                                Cancelar
                                            </el-button>                                    
                                        </div>
                                    </div>
                                </div>
                            </el-dialog>
                            <div style="display: flex; justify-content: center; gap: 1rem;">
                                <el-button class="btn" type="primary" v-on:click="validateForm">
                                    Guardar
                                </el-button>
                                <a href="/">
                                    <el-button class="btn" type="info">
                                        Volver
                                    </el-button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
  import api from '../../api'
  import PdfFile from '../PdfFile.vue'
  import UploadOrder from './UploadOrder.vue'
  export default {
    name: 'Prebill',
    components: {
      'pdf-file': PdfFile,
      'upload-order': UploadOrder
    },
    props: {
      loadOperationType: {
        type: Boolean
      }
    },
    data () {
      return {
        showModal: false,
        isLoading: false,
        providers: [],
        formRules: {
          documenttype: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' }
          ],
          codigoAFIP: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }
          ],
          letra: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[A-Za-z]+$/, message: 'Solo se permiten letras en este campo', trigger: 'change' }
          ],
          numero: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }
          ],
          proveedor: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' }
          ],
          fechaVencimiento: [
              { type: 'date', required: true, message: 'Este campo es obligatorio', trigger: 'change' }
          ],
          NroCAE: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }
          ],
          pdfDoc: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' }
          ],
          importeTotal: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }
          ],
          importeImpuesto: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }
          ],
          porcentajeImpuesto: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }
          ],
          moneda: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[A-Za-z]+$/, message: 'Solo se permiten letras en este campo', trigger: 'change' }
          ],
          tipoDeCambio: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }
          ]
        },
        document: {
          documenttype: '',
          ocType: '',
          ocNumbers: [],
          pdfDoc: '',
          migoNumber: '',
          codigoAFIP: '',
          letra: '',
          numero: '',
          proveedor: this.$store.state.user.isProvider ? this.$store.state.user.idCompany : '',
          fechaVencimiento: '',
          NroCAE: '',
          importeTotal: '',
          importeImpuesto: '',
          porcentajeImpuesto: '',
          moneda: '',
          tipoDeCambio: ''
        },
        documentType: [{value: '1', label: 'Factura'}, {value: '2', label: 'Nota de crédito'}, {value: '3', label: 'Nota de débito'}],
        acceptanceType: [{value: '1', label: 'HES'}, {value: '2', label: 'MIGO'}],
        habModificaPdf: true
      }
    },
    methods: {
      addOcNumber () {
        this.document.ocNumbers.push({ value: '' })
      },
      deleteOcNumber (index) {
        this.document.ocNumbers.splice(index, 1)
      },
      validateForm () {
        this.$refs.formRef.validate((valid) => {
          if (valid) {
            this.showModal = true
          } else {
            this.$message.error('Debe completar todos los campos')
          }
        })
      },
      clog () {
        console.log('document', this.document)
        this.showModal = false
      },
      getProviders () {
        this.$store.commit('START_LOADING')
        api.request('GET', 'api/getProvidersNames')
        .then(response => {
          this.providers = response.data
          this.$store.commit('STOP_LOADING')
        })
        .catch(error => {
          console.log(error)
          this.$store.commit('STOP_LOADING')
        })
      },
      createDocument () {
        api.request('POST', 'api/createPrebill', JSON.stringify(this.document))
          .then((response) => {
            console.log('data', response.data)
            this.$message({
              message: 'Documento creado correctamente',
              type: 'success',
              duration: 5000
            })
            this.$router.push('/')
          })
          .catch((error) => {
            this.$message({
              message: 'Ha fallado la carga del documento',
              type: 'error',
              duration: 5000
            })
            console.log(error)
          })
      }
    },
    beforeMount () {
      this.getProviders()
    }
  }
</script>
<style scoped>
.prebillContainer{
    display: flex;
    flex-direction: column;
}
.prebill{
    display: flex;
    justify-content: center;
    align-items: center;
}

.box{
    max-width: 90vw;
    margin: 0 auto;
}
.form-select{
    margin-left: 0px;
}

@media screen and (max-width: 550px) {
    .form-select{
        margin-left: 0px;
    }
    .el-form-item{
        display: flex;
        flex-direction: column;
        justify-content: start;
    }
    .el-select-dropdown{
        left: 0 !important;
        min-width: auto;
        max-width: 90vw !important;
        overflow: auto !important;
    }
    .el-form-item--small{
        margin-bottom: 5px !important;
        margin-right: 10px;
        max-width: 90vw;
    }
    .box-body{
        overflow: auto;
    }
}
</style>

<style>
    .el-form-item__label-wrap{
        margin-left: 0px !important;
    }
    .box-body-prebill .el-input__inner {
        max-width: 90%;
    }   
</style>



// WEBPACK FOOTER //
// Prebill.vue?956cd038